<dealer-display></dealer-display>

<div class="container w-80 mt-5">
  <div class="p-4 pt-2">
    <div class="row mb-3">
      <div class="col-md-6 offset-md-3">
        <div class="text-break">
          <div class="verification-body mb-5">
            <p class="mb-4 text-center verification-header">
              ID Verification Required
            </p>
            <p>To help us verify your order and protect your account, we need a few extra details. Please email our support team at <a
                href="mailto:idsupport@dodo.com.au?subject=ID&nbsp;Verification">idsupport&#64;dodo.com.au</a>
              with
              the following:
            </p>
            <ul>
              <li>Full name</li>
              <li>Email address</li>
              <li>Mobile number</li>
            </ul>
            <p>Once we receive your information and complete the necessary checks, we can proceed with your order. Thank
              you for your patience.</p>
          </div>
          <div class="row">
            <div class="col-md-6 col-sm-12">
              <button class="return-btn"
                      (click)="gotoMainSite()"
                  >
                  Return to dodo.com
              </button>
            </div>
            <div class="col-md-6 col-sm-12">
              <button href="mailto:idsupport@iprimus.com.au?subject=ID&nbsp;Verification"
                  class="email-button" (click)="mail()"
                  >
                  <img src="/assets/img/send.svg" width="14" height="14"/>
                  Email Us
              </button>
            </div>
          </div>
      </div>
    </div>
  </div>
</div>
